import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=688afbdb&scoped=true&"
import script from "./Recaptcha.vue?vue&type=script&lang=js&"
export * from "./Recaptcha.vue?vue&type=script&lang=js&"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=688afbdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688afbdb",
  null
  
)

export default component.exports